export default __webpack_public_path__ + "static/media/Individual rank card.d0352d78.svg";